import { Observable } from 'rxjs';

import moment from 'moment/moment';

export const BOT_MESSAGE_ICON_DEFAULT = 'chat-logo-smile';
export const BOT_MESSAGE_ICON_LOADING = 'chat-logo-default';

export class Message {
    public readonly time: number;
    public readonly trackBy: string;
    public iconName?: string;

    constructor(
        public readonly type: MessageType,
        public text?: string
    ) {
        this.time = moment.utc().valueOf();
        this.trackBy = `${this.time}_${this.type}`;
    }
}

export class UserMessage extends Message {
    constructor(public text?: string) {
        super(MessageType.User, text);
    }
}

export class BotMessage extends Message {
    iconName: string;

    constructor(
        public text: string,
        public isStreaming = false
    ) {
        super(MessageType.Bot, text);

        this.iconName = isStreaming ? BOT_MESSAGE_ICON_LOADING : BOT_MESSAGE_ICON_DEFAULT;
    }
}

export class LoadingMessage extends Message {
    iconName: string = 'chat-logo-default';

    constructor() {
        super(MessageType.Loading);
    }
}

export enum MessageType {
    Bot = 'bot',
    User = 'user',
    Loading = 'loading'
}

export interface IApiService {
    getBotResponse(text: string): Observable<string>;
}
